import { KeyValue } from '@angular/common';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TIPOLOGIA_DATALIST_NAME, TITULO_DATALIST_NAME, GRUPO_CLASIFICACION_DATALIST_NAME, CLASIFICACION_DATALIST_NAME, DIVISION_DATALIST_NAME, SUBDIVISION_DATALIST_NAME, SUBDIVISION_ESP_DATALIST_NAME, CATEGORIA_DATALIST_NAME, DEPOSITO_DATALIST_NAME, NIVEL_DESC_DATALIST_NAME, FONDO_DATALIST_NAME, DESCRIPTOR_DATALIST_NAME, CONSERVACION_DATALIST_NAME, ACCESO_DATALIST_NAME, VALORACION_DATALIST_NAME, SUBDIVISION_NOMINAL_GAUDE_DATALIST_NAME, CURSO_ALUMNO_GAUDE_DATALIST_NAME, CURSO_ALUMNO_FORMACION_DATALIST_NAME } from '../../../model/contants/datalists';
import { CATEGORIA_FIELD, TIPOLOGIA_FIELD, TITULO_FIELD, DEPOSITO_PROVISIONAL_FIELD, NIVEL_DESC_FIELD, FECHA_INICIO_FIELD, FECHA_FIN_FIELD, VOLUMEN_SOP_FIELD, FONDO_FIELD, GRUPO_CLASIFICACION_FIELD, CLASIFICACION_FIELD, DIVISION_FIELD, SUBDIVISION_FIELD, SUBDIVISION_ESP_FIELD, SUBDIVISION_NOM_FIELD, ALCANCE_CONTENIDO_FIELD, DESCRIPTORES_FIELD, TESAURO_FIELD, DATOS_PRINCIPALES_STEP, AUTORES_STEP, CLASIFICACION_STEP, INFORMACION_STEP, CONTEXTO_STEP, FICHEROS_STEP, UBICACIONES_STEP, ACCESO_FIELD, CONSERVACION_FIELD, DOCUMENTOS_ASOCIADOS_FIELD, LENGUA_FIELD, LOCALIZACION_FIELD, NOTAS_FIELD, REPRODUCCION_FIELD, VALORACION_FIELD, FILES_FIELD, LOCATIONS_FIELD, AUTHORS_FIELD, LOANS_FIELD, LOANS_STEP, BOUDS_STEP, BOUDS_FIELD, LOANS_HISTORY_STEP, LOANS_HISTORY_FIELD, RECORD_WATERMARK_TEXT } from '../../../model/contants/udeu-record';
import { MatFormFieldType } from '../../../model/enums/mat-form-field-types';
import { UDeuStep, FormFieldMenuOption, UDeuStepFormField } from '../../../model/classes/udeu-step';
import { StepTypes } from '../../../model/enums/step-types';
import { AttachedFile } from '../../../../../../alden-extension/src/lib/models/attached-file';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppStore, getUserProfile, SnackbarErrorAction, SnackbarWarningAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { UdeuService } from '../../../services/udeu.service';
import { UdeuAuthor, UdeuClassification, UdeuContext, UdeuCreateRecord, UdeuData, UdeuEditMassiveRecord, UdeuInfo, UdeuLocation, UdeuRecord } from '../../../model/classes/udeu-record';
import { Router } from '@angular/router';
import { RecordActionTypes } from '../../../store/actions/record-actions';
import { ReloadCustomListTableAction } from 'projects/alden-extension/src/lib/store/actions/alden.actions';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Student } from '../../../model/classes/gaude-student';
import { GROUP_ADMIN, GROUP_ARCHIVERO, UDEU_LOAN_BORROWED_STATUS, UDEU_LOAN_FINISHED_STATUS, UDEU_LOAN_IN_PROGRESS_STATUS, UDEU_LOAN_RETURNED_STATUS, UDEU_RECORD_CAMPUS_SAN_SEBASTIAN, UDEU_RECORD_EXPEDIENTE_TYPOLOGY_KEY, UDEU_RECORD_FORMACION_ACCESS, UDEU_RECORD_FORMACION_CATEGORIA, UDEU_RECORD_FORMACION_CLASSIFICATION, UDEU_RECORD_FORMACION_CLASSIFICATION_GROUP, UDEU_RECORD_FORMACION_DIVISON, UDEU_RECORD_FORMACION_FUND, UDEU_RECORD_FORMACION_LEVEL_DESC, UDEU_RECORD_FORMACION_SUPPORT_VOLUME, UDEU_RECORD_FORMACION_VALUATION, UDEU_RECORD_GAUDE_CAMPUS0_DESCRIPTORS, UDEU_RECORD_GAUDE_CAMPUS1_ACCESS, UDEU_RECORD_GAUDE_CAMPUS1_CLASSIFICATION, UDEU_RECORD_GAUDE_CAMPUS1_CLASSIFICATION_GROUP, UDEU_RECORD_GAUDE_CAMPUS1_DESCRIPTORS, UDEU_RECORD_GAUDE_CAMPUS1_DIVISON, UDEU_RECORD_GAUDE_CAMPUS1_FUND, UDEU_RECORD_GAUDE_CAMPUS1_LEVEL_DESC, UDEU_RECORD_GAUDE_CAMPUS1_NOMINAL_SUBDIVISION, UDEU_RECORD_GAUDE_CAMPUS1_PROV_DEPOSIT, UDEU_RECORD_GAUDE_CAMPUS1_SUPPORT_VOLUME, UDEU_RECORD_GAUDE_CAMPUS1_VALUATION, UDEU_RECORD_STUDENT_TITLE_KEY, UDEU_RECORD_TRAINING_TITLE_KEY } from '../../../model/contants/deusto';
import { UDEU_RECORD_GAUDE_CAMPUS0_ACCESS, UDEU_RECORD_GAUDE_CAMPUS0_CLASSIFICATION, UDEU_RECORD_GAUDE_CAMPUS0_CLASSIFICATION_GROUP, UDEU_RECORD_GAUDE_CAMPUS0_DIVISON, UDEU_RECORD_GAUDE_CAMPUS0_FUND, UDEU_RECORD_GAUDE_CAMPUS0_LEVEL_DESC, UDEU_RECORD_GAUDE_CAMPUS0_NOMINAL_SUBDIVISION, UDEU_RECORD_GAUDE_CAMPUS0_PROV_DEPOSIT, UDEU_RECORD_GAUDE_CAMPUS0_SUPPORT_VOLUME, UDEU_RECORD_GAUDE_CAMPUS0_VALUATION } from '../../../model/contants/deusto';
import { SGAData } from '../../../model/classes/sga-data';
import { Formacion } from '../../../model/classes/gaude-formacion';
import { AlumnosCursoData } from '../../../model/classes/alumnos-curso-data';
import { DateType } from 'projects/alden-extension/src/lib/models/date-types';
import { Moment } from 'moment';
import { TranslationService } from '@alfresco/adf-core';
import { RecordService } from '../../../services/record.service';
import { ArrayValidators } from 'projects/alden-extension/src/lib/validators/array.validator';
import { SMTConfirmDialogComponent } from 'projects/alden-extension/src/lib/dialogs/confirm/confirm.dialog';
import { UdeuLoan } from '../../../model/classes/udeu-loan';
import { MatStep } from '@angular/material/stepper';
import { canManageLoan } from '../../../rules/loan.rules';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProfileState } from '@alfresco/adf-extensions';
import { UdeuCreateFile, UdeuFile } from '../../../model/classes/udeu-files';

import * as moment from 'moment';
import { canManageBoud } from '../../../rules/boud.rules';
import { SMTLoadingDialogComponent } from 'projects/alden-extension/src/lib/dialogs/loading/loading.dialog';
import { APP_CONFIG_FILE_SIZE_LIMIT } from 'projects/alden-extension/src/lib/models/alden-constants';
import { AldenService } from 'projects/alden-extension/src/lib/services/alden.service';
import { WatermarkParams } from 'projects/alden-extension/src/lib/models/watermark-params';

export interface DialogData {
  recordActionType: RecordActionTypes;
  UUIDs: string[];
  student: Student;
  formacion: Formacion;
  loan: UdeuLoan,
  openedByUrl?: boolean;
  selectedIndex?: number;
}

@Component({
  templateUrl: './create-record.dialog.html',
  styleUrls: ['./create-record.dialog.scss'],
})
export class CreateRecordDialogComponent implements OnInit {
  loading: boolean;

  steps: { [id: string]: UDeuStep };

  MatFormFieldType: typeof MatFormFieldType = MatFormFieldType;
  StepTypes: typeof StepTypes = StepTypes;
  RecordActionTypes: typeof RecordActionTypes = RecordActionTypes;
  DateType: typeof DateType = DateType;

  private _formBuilder = inject(FormBuilder);

  mainFormGroup: FormGroup<any>;
  clasificationFormGroup: FormGroup<any>;
  dataFormGroup: FormGroup<any>;
  authorsFormGroup: FormGroup<any>;
  infoFormGroup: FormGroup<any>;
  contextFormGroup: FormGroup<any>;
  filesFormGroup: FormGroup<any>;
  locationsFormGroup: FormGroup<any>;
  loansFormGroup: FormGroup<any>;
  loansHistoryFormGroup: FormGroup<any>;
  boudsFormGroup: FormGroup<any>;

  record: UdeuRecord;
  fundKey: string;
  divisionKey: string;

  editMassiveOptions: FormFieldMenuOption[];

  profile$: Observable<ProfileState>;
  isLoanManager: boolean;
  isBoudManager: boolean;

  selectedIndex: number;

  watermarkParams: WatermarkParams = {
    watermarkText:RECORD_WATERMARK_TEXT,
    red: 190,
    blue:190,
    green:190,
    transparency:100,
    radians:60
  }

  allowedDownloadGroups: string[] = [GROUP_ARCHIVERO, GROUP_ADMIN];

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, private dialogRef: MatDialogRef<CreateRecordDialogComponent>, 
  private dialog: MatDialog, protected store: Store<AppStore>, public udeuService: UdeuService, private recordService: RecordService,
  private router: Router, private translationService: TranslationService, private aldenService: AldenService) {
    this.profile$ = this.store.select(getUserProfile);
    this.editMassiveOptions = [
      { id: 'add', icon: 'add', label: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_MASSIVE_RECORD.OPTIONS.ADD.LABEL', placeholder: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_MASSIVE_RECORD.OPTIONS.ADD.PLACEHOLDER'}, 
      { id: 'replace', icon: 'autorenew', label: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_MASSIVE_RECORD.OPTIONS.REPLACE.LABEL', placeholder: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_MASSIVE_RECORD.OPTIONS.REPLACE.PLACEHOLDER'},
      { id: 'delete', icon: 'delete', label: 'APP.ACTIONS.DELETE', placeholder: 'APP.ACTIONS.DELETE'}];

  }

  async ngOnInit(): Promise<void> {
    this.loading = true; 
    this.beforeClosed();

    await this.initilizeForms();
    this.createSteps();

    const promises = this.data?.recordActionType !== RecordActionTypes.ViewRecord ? [
      // DATOS_PRINCIPALES_STEP
      this.udeuService.getMasterList(this.steps, DATOS_PRINCIPALES_STEP, CATEGORIA_FIELD, CATEGORIA_DATALIST_NAME),
      this.udeuService.getMasterList(this.steps, DATOS_PRINCIPALES_STEP, DEPOSITO_PROVISIONAL_FIELD, DEPOSITO_DATALIST_NAME),
      this.udeuService.getMasterList(this.steps, DATOS_PRINCIPALES_STEP, NIVEL_DESC_FIELD, NIVEL_DESC_DATALIST_NAME),
      
      // CLASIFICACION_STEP
      this.udeuService.getMasterList(this.steps, CLASIFICACION_STEP, FONDO_FIELD, FONDO_DATALIST_NAME),
      this.getGaudeList(CLASIFICACION_STEP, SUBDIVISION_NOM_FIELD, SUBDIVISION_NOMINAL_GAUDE_DATALIST_NAME),

      // INFORMACION_STEP
      this.udeuService.getMasterList(this.steps, INFORMACION_STEP, DESCRIPTORES_FIELD, DESCRIPTOR_DATALIST_NAME),

      // CONTEXTO_STEP
      this.udeuService.getMasterList(this.steps, CONTEXTO_STEP, VALORACION_FIELD, VALORACION_DATALIST_NAME),
      this.udeuService.getMasterList(this.steps, CONTEXTO_STEP, ACCESO_FIELD, ACCESO_DATALIST_NAME),
      this.udeuService.getMasterList(this.steps, CONTEXTO_STEP, CONSERVACION_FIELD, CONSERVACION_DATALIST_NAME),
    ] : [];

    await Promise.all(promises).then(async () => {
      this.profile$.pipe(
        take(1)
      ).subscribe(async (profile) => {
        this.isLoanManager = canManageLoan(profile);
        this.steps[LOANS_STEP].disabled = !this.isLoanManager ? true : this.steps[LOANS_STEP].disabled;
        this.isBoudManager = canManageBoud(profile);
        this.steps[BOUDS_STEP].disabled = !this.isBoudManager ? true : this.steps[BOUDS_STEP].disabled;

        await this.loadStudent();
        this.selectedIndex = this.data?.selectedIndex ? this.data.selectedIndex - (Object.values(this.steps).filter((step, index) => index < this.data.selectedIndex && step.disabled).length) : 0;
        this.loading = false;
      });
    }).catch((err) => { 
      console.error("ERROR", err);
      this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.RESPONSE.500'));
      this.dialogRef.close();
      this.loading = false;
    });
  }

  async initilizeForms() {
    const UUIDs = this.data.UUIDs;
    if(UUIDs?.length === 1) {
      await this.recordService.getRecord(UUIDs[0]).then((res) => { 
        this.record = res;
        if(this.data.recordActionType === RecordActionTypes.DuplicateRecord) {
          this.record.files = [];
          this.record.locations = [];
          this.record.loans = [];
        }
      });
    } else if(UUIDs?.length > 1) {
      await this.recordService.getMassiveRecords(UUIDs).then((res) => { 
        this.record = res;
      });
    }

    this.clasificationFormGroup = this._formBuilder.group({
      [FONDO_FIELD]: [this.record?.classification?.fund, [Validators.required]],
      [GRUPO_CLASIFICACION_FIELD]: [this.record?.classification?.classificationGroup, [Validators.required]],
      [CLASIFICACION_FIELD]: [this.record?.classification?.classification, [Validators.required]],
      [DIVISION_FIELD]: [this.record?.classification?.division, [Validators.required]],
      [SUBDIVISION_FIELD]: [this.record?.classification?.subdivision],
      [SUBDIVISION_ESP_FIELD]: [this.record?.classification?.specificSubdivision],
      [SUBDIVISION_NOM_FIELD]: [this.record?.classification?.nominalSubdivision, [Validators.required]],
    });
  
    this.dataFormGroup = this._formBuilder.group({
      [CATEGORIA_FIELD]: [this.record?.data?.category, [Validators.required]],
      [TIPOLOGIA_FIELD]: [this.record?.data?.typology, [Validators.required]],
      [TITULO_FIELD]: [this.record?.data?.title, [Validators.required]],
      [DEPOSITO_PROVISIONAL_FIELD]: [this.record?.data?.depositProv, [Validators.required]],
      [NIVEL_DESC_FIELD]: [this.record?.data?.descLevel],
      [FECHA_INICIO_FIELD]: [this.momentDate(this.record?.data?.startDate), [Validators.required]],
      [FECHA_FIN_FIELD]: [this.momentDate(this.record?.data?.endDate), [Validators.required]],
      [VOLUMEN_SOP_FIELD]: [this.record?.data?.supportVolume],
    });
  
    this.authorsFormGroup = this._formBuilder.group({
      [AUTHORS_FIELD]: this._formBuilder.array([])
    });
  
    this.infoFormGroup = this._formBuilder.group({
      [DESCRIPTORES_FIELD]: [this.record?.info?.descriptors, [Validators.required]],
      [TESAURO_FIELD]: [this.record?.info?.thesaurus?.map((thes) => { return { key: thes, value: thes }})],
      [ALCANCE_CONTENIDO_FIELD]: [this.record?.info?.scopeContent, [Validators.required]],
    });
  
    this.contextFormGroup = this._formBuilder.group({
      [VALORACION_FIELD]: [this.record?.context?.valuation],
      [ACCESO_FIELD]: [this.record?.context?.access, [Validators.required]],
      [LOCALIZACION_FIELD]: [this.record?.context?.location],
      [CONSERVACION_FIELD]: [this.record?.context?.conservation],
      [REPRODUCCION_FIELD]: [this.record?.context?.reproduction],
      [DOCUMENTOS_ASOCIADOS_FIELD]: [this.record?.context?.associatedDocuments],
      [LENGUA_FIELD]: [this.record?.context?.language],
      [NOTAS_FIELD]: [this.record?.context?.notes]
    });
  
    this.filesFormGroup = this._formBuilder.group({
      [FILES_FIELD]: [[]],
    });
  
    this.locationsFormGroup = this._formBuilder.group({
      [LOCATIONS_FIELD]: this._formBuilder.array([], ArrayValidators.required)
    });

    this.loansFormGroup = this._formBuilder.group({
      [LOANS_FIELD]: this._formBuilder.array([])
    });

    this.loansHistoryFormGroup = this._formBuilder.group({
      [LOANS_HISTORY_FIELD]: this._formBuilder.array([])
    });

    this.boudsFormGroup = this._formBuilder.group({
      [BOUDS_FIELD]: this._formBuilder.array([])
    });

    this.mainFormGroup = this._formBuilder.group({
      clasification: this.clasificationFormGroup,
      data: this.dataFormGroup,
      authors: this.authorsFormGroup,
      info: this.infoFormGroup,
      context: this.contextFormGroup,
      files: this.filesFormGroup,
      locations: this.locationsFormGroup,
      loans: this.loansFormGroup,
      loansHistory: this.loansHistoryFormGroup,
      bouds: this.boudsFormGroup
    });

    this.checkOpenEditionByUrl();

    if(this.data.recordActionType === RecordActionTypes.ViewRecord) {
      this.mainFormGroup.disable();
    };

    if(this.data.recordActionType === RecordActionTypes.EditMassiveRecord) {
      this.removeRequiredValidator(this.clasificationFormGroup);
      this.removeRequiredValidator(this.dataFormGroup);
      this.removeRequiredValidator(this.infoFormGroup);
    };
  }

  checkOpenEditionByUrl() {
    if(this.data?.openedByUrl) {
      this.data.recordActionType = RecordActionTypes.ViewRecord;
      this.mainFormGroup.disable();
    }
  }

  removeRequiredValidator(formGroup: FormGroup<any>) {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.get(controlName);
      if (control) {
        control.removeValidators(Validators.required);
        control.updateValueAndValidity();
      }
    });
  }

  async loadStudent(){
    const student = this.data.student;
    const formacion = this.data.formacion;
    if(student || formacion){
      this.record = this.record || new UdeuRecord();
      this.record.info = this.record.info || new UdeuInfo();
      this.record.data = this.record.data || new UdeuData();
      this.record.context = this.record.context || new UdeuContext();
      this.record.classification = this.record.classification || new UdeuClassification();
      this.record.authors = this.record.authors || [];

      if(this.data.recordActionType === RecordActionTypes.CreateRecord && student) {
        await this.loadGaudeDefaultInfo(student);
      } else if(this.data.recordActionType === RecordActionTypes.CreateRecord && formacion) {
        await this.loadFormacionDefaultInfo(formacion);
      }
    }
  }

  async loadGaudeDefaultInfo(student: Student) {
    // Rellenar datos de autor
    const author = new UdeuAuthor();
    author.gaudeId = student.id_entidad;
    author.ria = student.identificativo;
    author.name = student.nombre;
    author.lastname1 = student.apellido1;
    author.lastname2 = student.apellido2;
    this.record.authors.push(author);

    // Obtener más datos, el curso
    await this.udeuService.getGaudeDataListValues(CURSO_ALUMNO_GAUDE_DATALIST_NAME, student.id_entidad).then((res: SGAData) => {   
      this.infoFormGroup.get(ALCANCE_CONTENIDO_FIELD).setValue(res.Curso);
      this.contextFormGroup.get(NOTAS_FIELD).setValue(res.Notas);
      this.dataFormGroup.get(FECHA_INICIO_FIELD).setValue(this.formatDate(res.fechainicio));
      this.dataFormGroup.get(FECHA_FIN_FIELD).setValue(this.formatDate(res.FechaFin));
    });

    const promises = [
      // CLASIFICACION_STEP
      this.getList(CLASIFICACION_STEP, GRUPO_CLASIFICACION_FIELD, GRUPO_CLASIFICACION_DATALIST_NAME, student.campus === "1" ? UDEU_RECORD_GAUDE_CAMPUS1_FUND : UDEU_RECORD_GAUDE_CAMPUS0_FUND, false, true),
      this.getList(CLASIFICACION_STEP, CLASIFICACION_FIELD, CLASIFICACION_DATALIST_NAME, student.campus === "1" ? UDEU_RECORD_GAUDE_CAMPUS1_CLASSIFICATION_GROUP : UDEU_RECORD_GAUDE_CAMPUS0_CLASSIFICATION_GROUP, false, true),
      this.getList(CLASIFICACION_STEP, DIVISION_FIELD, DIVISION_DATALIST_NAME, student.campus === "1" ? UDEU_RECORD_GAUDE_CAMPUS1_CLASSIFICATION : UDEU_RECORD_GAUDE_CAMPUS0_CLASSIFICATION, false, true),
    
      // DATOS_PRINCIPALES_STEP
      this.getList(DATOS_PRINCIPALES_STEP, CATEGORIA_FIELD, CATEGORIA_DATALIST_NAME, student.campus === "1" ? UDEU_RECORD_GAUDE_CAMPUS1_DIVISON : UDEU_RECORD_GAUDE_CAMPUS0_DIVISON, false, true),
      this.getList(DATOS_PRINCIPALES_STEP, TIPOLOGIA_FIELD, TIPOLOGIA_DATALIST_NAME, UDEU_RECORD_FORMACION_CATEGORIA, false, true),
      this.getList(DATOS_PRINCIPALES_STEP, TITULO_FIELD, TITULO_DATALIST_NAME, UDEU_RECORD_EXPEDIENTE_TYPOLOGY_KEY, false, true),
    ];

    // Rellenar campos por defecto dependiendo del campus
    await Promise.all(promises).then(() =>{
      switch(student.campus){
        //SAN SEBASTIÁN
        case UDEU_RECORD_CAMPUS_SAN_SEBASTIAN: 
          // CLASIFICACION_STEP
          this.clasificationFormGroup.get(FONDO_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[FONDO_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS1_FUND));
          this.clasificationFormGroup.get(GRUPO_CLASIFICACION_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[GRUPO_CLASIFICACION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS1_CLASSIFICATION_GROUP));
          this.clasificationFormGroup.get(CLASIFICACION_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[CLASIFICACION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS1_CLASSIFICATION));
          this.clasificationFormGroup.get(DIVISION_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[DIVISION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS1_DIVISON));
          this.clasificationFormGroup.get(SUBDIVISION_NOM_FIELD).setValue([this.steps[CLASIFICACION_STEP].form.fields[SUBDIVISION_NOM_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS1_NOMINAL_SUBDIVISION)]);
          
          // DATOS_PRINCIPALES_STEP
          this.dataFormGroup.get(DEPOSITO_PROVISIONAL_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[DEPOSITO_PROVISIONAL_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS1_PROV_DEPOSIT));
          this.dataFormGroup.get(NIVEL_DESC_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[NIVEL_DESC_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS1_LEVEL_DESC));
          this.dataFormGroup.get(VOLUMEN_SOP_FIELD).setValue(UDEU_RECORD_GAUDE_CAMPUS1_SUPPORT_VOLUME);
          this.dataFormGroup.get(TIPOLOGIA_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[TIPOLOGIA_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_EXPEDIENTE_TYPOLOGY_KEY));
          this.dataFormGroup.get(TITULO_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[TITULO_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_STUDENT_TITLE_KEY));
          
          // INFORMACION_STEP
          const campus1Descriptors = [];
          UDEU_RECORD_GAUDE_CAMPUS1_DESCRIPTORS.forEach((desc) => campus1Descriptors.push(this.steps[INFORMACION_STEP].form.fields[DESCRIPTORES_FIELD].options.find((opt)=> opt.key === desc)));
          this.infoFormGroup.get(DESCRIPTORES_FIELD).setValue(campus1Descriptors);

          // CONTEXTO_STEP
          this.contextFormGroup.get(VALORACION_FIELD).setValue(this.steps[CONTEXTO_STEP].form.fields[VALORACION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS1_VALUATION));
          this.contextFormGroup.get(ACCESO_FIELD).setValue(this.steps[CONTEXTO_STEP].form.fields[ACCESO_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS1_ACCESS));
          break;
          //BILBAO
          default:
            // CLASIFICACION_STEP
            this.clasificationFormGroup.get(FONDO_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[FONDO_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS0_FUND));
            this.clasificationFormGroup.get(GRUPO_CLASIFICACION_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[GRUPO_CLASIFICACION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS0_CLASSIFICATION_GROUP));
            this.clasificationFormGroup.get(CLASIFICACION_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[CLASIFICACION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS0_CLASSIFICATION));
            this.clasificationFormGroup.get(DIVISION_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[DIVISION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS0_DIVISON));
            this.clasificationFormGroup.get(SUBDIVISION_NOM_FIELD).setValue([this.steps[CLASIFICACION_STEP].form.fields[SUBDIVISION_NOM_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS0_NOMINAL_SUBDIVISION)]);
            
            // DATOS_PRINCIPALES_STEP
            this.dataFormGroup.get(DEPOSITO_PROVISIONAL_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[DEPOSITO_PROVISIONAL_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS0_PROV_DEPOSIT));
            this.dataFormGroup.get(NIVEL_DESC_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[NIVEL_DESC_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS0_LEVEL_DESC));
            this.dataFormGroup.get(VOLUMEN_SOP_FIELD).setValue(UDEU_RECORD_GAUDE_CAMPUS0_SUPPORT_VOLUME);      
            this.dataFormGroup.get(TIPOLOGIA_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[TIPOLOGIA_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_EXPEDIENTE_TYPOLOGY_KEY));
            this.dataFormGroup.get(TITULO_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[TITULO_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_STUDENT_TITLE_KEY));
            
            // INFORMACION_STEP
            const campus0Descriptors = [];
            UDEU_RECORD_GAUDE_CAMPUS0_DESCRIPTORS.forEach((desc) => campus0Descriptors.push(this.steps[INFORMACION_STEP].form.fields[DESCRIPTORES_FIELD].options.find((opt)=> opt.key === desc)));
            this.infoFormGroup.get(DESCRIPTORES_FIELD).setValue(campus0Descriptors);

            // CONTEXTO_STEP
            this.contextFormGroup.get(VALORACION_FIELD).setValue(this.steps[CONTEXTO_STEP].form.fields[VALORACION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS0_VALUATION));
            this.contextFormGroup.get(ACCESO_FIELD).setValue(this.steps[CONTEXTO_STEP].form.fields[ACCESO_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS0_ACCESS));
            break;
      }
    }).catch((err) => { 
      console.error("ERROR", err);
      this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.RESPONSE.500'));
      this.dialogRef.close();
    });
  }

  async loadFormacionDefaultInfo(formacion: Formacion) {
    // Obtener más datos, el curso
    await this.udeuService.getGaudeDataListValues(CURSO_ALUMNO_FORMACION_DATALIST_NAME, formacion.idcurso, formacion.año_imparticion).then((res: AlumnosCursoData) => {   
      let data = `${formacion.idcurso} / ${formacion.nombre_curso} / ${formacion.num_edicion} / ${formacion.centro} / ${formacion.año_imparticion} / ${formacion.campus} \n`;
      res?.items?.forEach(element => {
        data += "\n" + element['dni||\'\'||nombre||\'\'||apellido1||\'\'||apellido2']
      });
      this.infoFormGroup.get(ALCANCE_CONTENIDO_FIELD).setValue(data);
    });

    const promises = [
      // CLASIFICACION_STEP
      this.getList(CLASIFICACION_STEP, GRUPO_CLASIFICACION_FIELD, GRUPO_CLASIFICACION_DATALIST_NAME, UDEU_RECORD_FORMACION_FUND, false, true),
      this.getList(CLASIFICACION_STEP, CLASIFICACION_FIELD, CLASIFICACION_DATALIST_NAME, UDEU_RECORD_FORMACION_CLASSIFICATION_GROUP, false, true),
      this.getList(CLASIFICACION_STEP, DIVISION_FIELD, DIVISION_DATALIST_NAME, UDEU_RECORD_FORMACION_CLASSIFICATION, false, true),
    
      // DATOS_PRINCIPALES_STEP
      this.getList(DATOS_PRINCIPALES_STEP, CATEGORIA_FIELD, CATEGORIA_DATALIST_NAME, UDEU_RECORD_FORMACION_DIVISON, false, true),
      this.getList(DATOS_PRINCIPALES_STEP, TIPOLOGIA_FIELD, TIPOLOGIA_DATALIST_NAME, UDEU_RECORD_FORMACION_CATEGORIA, false, true),
      this.getList(DATOS_PRINCIPALES_STEP, TITULO_FIELD, TITULO_DATALIST_NAME, UDEU_RECORD_EXPEDIENTE_TYPOLOGY_KEY, false, true),
    ];

    // Rellenar campos por defecto dependiendo del campus
    await Promise.all(promises).then(() => {
       // CLASIFICACION_STEP
       this.clasificationFormGroup.get(FONDO_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[FONDO_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_FORMACION_FUND));
       this.clasificationFormGroup.get(GRUPO_CLASIFICACION_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[GRUPO_CLASIFICACION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_FORMACION_CLASSIFICATION_GROUP));
       this.clasificationFormGroup.get(CLASIFICACION_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[CLASIFICACION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_FORMACION_CLASSIFICATION));
       this.clasificationFormGroup.get(DIVISION_FIELD).setValue(this.steps[CLASIFICACION_STEP].form.fields[DIVISION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_FORMACION_DIVISON));

       // DATOS_PRINCIPALES_STEP
       this.dataFormGroup.get(NIVEL_DESC_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[NIVEL_DESC_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_FORMACION_LEVEL_DESC));
       this.dataFormGroup.get(VOLUMEN_SOP_FIELD).setValue(UDEU_RECORD_FORMACION_SUPPORT_VOLUME);          
       this.dataFormGroup.get(TIPOLOGIA_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[TIPOLOGIA_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_EXPEDIENTE_TYPOLOGY_KEY));
       this.dataFormGroup.get(TITULO_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[TITULO_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_TRAINING_TITLE_KEY));

       // CONTEXTO_STEP
       this.contextFormGroup.get(VALORACION_FIELD).setValue(this.steps[CONTEXTO_STEP].form.fields[VALORACION_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_FORMACION_VALUATION));
       this.contextFormGroup.get(ACCESO_FIELD).setValue(this.steps[CONTEXTO_STEP].form.fields[ACCESO_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_FORMACION_ACCESS));
       
      switch(formacion.idcampus){
        //SAN SEBASTIÁN
        case UDEU_RECORD_CAMPUS_SAN_SEBASTIAN:
          this.dataFormGroup.get(DEPOSITO_PROVISIONAL_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[DEPOSITO_PROVISIONAL_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS1_PROV_DEPOSIT));
          break;
        //BILBAO
        default: 
          this.dataFormGroup.get(DEPOSITO_PROVISIONAL_FIELD).setValue(this.steps[DATOS_PRINCIPALES_STEP].form.fields[DEPOSITO_PROVISIONAL_FIELD].options.find((opt)=> opt.key === UDEU_RECORD_GAUDE_CAMPUS0_PROV_DEPOSIT));
          break;
      }
    }).catch((err) => { 
      console.error("ERROR", err);
      this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.RESPONSE.500'));
      this.dialogRef.close();
    });
  }

  createSteps() {
    this.steps = {
      [CLASIFICACION_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.CLASSIFICATION.TITLE",
        type: StepTypes.GENERIC,
        form: {
          group: this.clasificationFormGroup,
          fields: {
            [FONDO_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CLASSIFICATION.FUND", style: { width: '100%' },
              changeFunc: [
                (option) => this.setFund(option),
                (option, reset?) => this.getList(CLASIFICACION_STEP, GRUPO_CLASIFICACION_FIELD, GRUPO_CLASIFICACION_DATALIST_NAME, option?.key, reset)
              ]
            },
            [GRUPO_CLASIFICACION_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CLASSIFICATION.CLASSIFICATION_GROUP",
              changeFunc: [(option, reset?) => this.getListWithMasterKey(CLASIFICACION_STEP, CLASIFICACION_FIELD, CLASIFICACION_DATALIST_NAME, option?.key, this.fundKey, reset)]
            },
            [CLASIFICACION_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CLASSIFICATION.CLASSIFICATION",
              changeFunc: [(option, reset?) => this.getListWithMasterKey(CLASIFICACION_STEP, DIVISION_FIELD, DIVISION_DATALIST_NAME, option?.key, this.fundKey, reset)]
            },
            [DIVISION_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CLASSIFICATION.DIVISION",
              changeFunc: [
                (option) => this.setDivision(option),
                (option, reset?) => this.getListAndValidators(CLASIFICACION_STEP, SUBDIVISION_FIELD, SUBDIVISION_DATALIST_NAME, option?.key, this.fundKey, reset), 
                (option, reset?) => this.getListAndValidators(CLASIFICACION_STEP, SUBDIVISION_ESP_FIELD, SUBDIVISION_ESP_DATALIST_NAME, option?.key, this.fundKey, reset),
                (option, reset?) => this.getList(DATOS_PRINCIPALES_STEP, CATEGORIA_FIELD, CATEGORIA_DATALIST_NAME, option?.key, reset)]
            },
            [SUBDIVISION_FIELD]: { type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CLASSIFICATION.SUBDIVISION", optional: true },
            [SUBDIVISION_ESP_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CLASSIFICATION.SPECIFIC_SUBDIVISION",  optional: true},
            [SUBDIVISION_NOM_FIELD]: { type: MatFormFieldType.SELECT_MULTIPLE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CLASSIFICATION.NOMINAL_SUBDIVISION", style: { width: '100%' } },
          }
        }
      },
      [DATOS_PRINCIPALES_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.MAIN_DATA.TITLE",
        type: StepTypes.GENERIC,
        form: {
          group: this.dataFormGroup,
          fields: {
            [CATEGORIA_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.CATEGORY", style: { width: '100%' },
              changeFunc: [(option, reset?) => this.getListWithMasterKey(DATOS_PRINCIPALES_STEP, TIPOLOGIA_FIELD, TIPOLOGIA_DATALIST_NAME, option?.key, this.divisionKey, reset)]
            },
            [TIPOLOGIA_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.TYPOLOGY", style: { width: '100%' },
              changeFunc: [(option, reset?) => this.getListWithMasterKey(DATOS_PRINCIPALES_STEP, TITULO_FIELD, TITULO_DATALIST_NAME, option?.key, this.divisionKey, reset)]
            },
            [TITULO_FIELD]: { type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.TITLE", style: { width: '100%' } },
            [DEPOSITO_PROVISIONAL_FIELD]: { type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.PROVISIONAL_DEPOSIT", disabled: this.data.recordActionType === RecordActionTypes.EditMassiveRecord },
            [NIVEL_DESC_FIELD]: { type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.LEVEL_DESCRIPTION" , optional: true},
            [FECHA_INICIO_FIELD]: { type: MatFormFieldType.DATE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.DATE", placeholder: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.START_DATE", extraControlName: FECHA_FIN_FIELD, extraPlaceholder: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.END_DATE", disabled: this.data.recordActionType === RecordActionTypes.EditMassiveRecord },
            [VOLUMEN_SOP_FIELD]: { type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.VOLUME_SUPPORT", disabled: this.data.recordActionType === RecordActionTypes.EditMassiveRecord , optional: true},
          }
        }
      },
      [AUTORES_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.AUTHORS.TITLE",
        type: StepTypes.AUTHORS,
        form: {
          group: this.authorsFormGroup,
          fields: { [AUTHORS_FIELD]: {} }
        }
      },
      [INFORMACION_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.INFORMATION.TITLE",
        type: StepTypes.GENERIC,
        form: {
          group: this.infoFormGroup, 
          fields: {
            [DESCRIPTORES_FIELD]: {
              type: MatFormFieldType.SELECT_MULTIPLE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.INFORMATION.DESCRIPTORS", style: { width: '100%' },
            },
            [TESAURO_FIELD]: { type: MatFormFieldType.SELECT_MULTIPLE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.INFORMATION.THESAURUS", style: { width: '100%' }, options: [{ key: "1TES1", value: "1TES1" }, { key: "2TES2", value: "2TES2" }], optional: true},
            [ALCANCE_CONTENIDO_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.INFORMATION.SCOPE_CONTENT", style: { width: '100%' },
            },         
          }
        }
      },
      [CONTEXTO_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.CONTEXT.TITLE",
        type: StepTypes.GENERIC,
        disabled: this.data.recordActionType === RecordActionTypes.EditMassiveRecord,
        form: {
          group: this.contextFormGroup, 
          fields: {
            [VALORACION_FIELD]: { type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CONTEXT.VALUATION" },
            [ACCESO_FIELD]: { type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CONTEXT.ACCESS" },
            [LOCALIZACION_FIELD]: { type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CONTEXT.LOCATION" },
            [CONSERVACION_FIELD]: { type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CONTEXT.CONSERVATION" },
            [REPRODUCCION_FIELD]: { type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CONTEXT.REPRODUCTION" },
            [DOCUMENTOS_ASOCIADOS_FIELD]: { type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CONTEXT.ASSOCIATED_DOCUMENTS" },
            [LENGUA_FIELD]: { type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CONTEXT.LANGUAGE" },
            [NOTAS_FIELD]: { type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.CONTEXT.NOTES" },
          }
        }
      },
      [FICHEROS_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.FILES.TITLE",
        type: StepTypes.FILES,
        disabled: this.data.recordActionType === RecordActionTypes.EditMassiveRecord,
        form: {
          group: this.filesFormGroup
        }
      },
      [UBICACIONES_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOCATIONS.TITLE",
        type: StepTypes.LOCATIONS,
        disabled: this.data.recordActionType === RecordActionTypes.EditMassiveRecord,
        form: {
          group: this.locationsFormGroup
        }
      },
      [LOANS_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOANS.TITLE",
        type: StepTypes.LENTS,
        disabled: !((this.data.recordActionType === RecordActionTypes.ViewRecord || this.data.recordActionType === RecordActionTypes.EditRecord) 
                      && this.record?.loans?.some((loan) => {
                        const loanStatus = (loan.status.status as KeyValue<string, string>).key;
                        return loanStatus === UDEU_LOAN_BORROWED_STATUS || loanStatus === UDEU_LOAN_IN_PROGRESS_STATUS;
                      })),
        form: {
          group: this.loansFormGroup
        }
      },
      [LOANS_HISTORY_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOANS_HISTORY.TITLE",
        type: StepTypes.LOANS_HISTORY,
        disabled: !((this.data.recordActionType === RecordActionTypes.ViewRecord || this.data.recordActionType === RecordActionTypes.EditRecord) 
                      && this.record?.loans?.some((loan) => {
                        const loanStatus = (loan.status.status as KeyValue<string, string>).key;
                        return loanStatus === UDEU_LOAN_RETURNED_STATUS || loanStatus === UDEU_LOAN_FINISHED_STATUS;
                      })),
        form: {
          group: this.loansHistoryFormGroup
        }
      },
      [BOUDS_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.BOUDS.TITLE",
        type: StepTypes.BOUD,
        disabled: !((this.data.recordActionType === RecordActionTypes.ViewRecord || this.data.recordActionType === RecordActionTypes.EditRecord) 
                      && this.record?.bouds?.length > 0),
        form: {
          group: this.boudsFormGroup
        }
      },
    }
  }

  beforeClosed() {
    // Interceptamos el evento de cerrar el diálogo
    this.dialogRef.backdropClick().subscribe(() => {
      this.closeDialog();
    });

    // Interceptamos el evento de presionar la tecla Esc
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.closeDialog();
      }
    });
  }

  setFund(option: KeyValue<string, string>) {
    this.fundKey = option?.key ?? '';
  }

  setDivision(option: KeyValue<string, string>) {
    this.divisionKey = option?.key ?? '';
  }

  getList(stepId: string, fieldName: string, dataListName: string, parentKey?: string, reset?: boolean, needParentKey: boolean = true): Promise<any[]> {
    return this.data?.recordActionType === RecordActionTypes.ViewRecord ? null :
    this.udeuService.getList(this.steps, stepId, fieldName, dataListName, parentKey, reset, needParentKey);
  }

  getListWithMasterKey(stepId: string, fieldName: string, dataListName: string, parentKey?: string, masterKey?: string, reset?: boolean, needParentKey: boolean = true): Promise<any[]> {
    return this.data?.recordActionType === RecordActionTypes.ViewRecord ? null :
    this.udeuService.getListWithMasterKey(this.steps, stepId, fieldName, dataListName, parentKey, masterKey, reset, needParentKey);
  }

  getGaudeList(stepId: string, fieldName: string, dataListName: string, value?: string): Promise<any[]> {
    return this.data?.recordActionType === RecordActionTypes.ViewRecord ? null : 
    this.udeuService.getGaudeList(this.steps, stepId, fieldName, dataListName, value);
  }

  getListAndValidators(stepId: string, fieldName: string, dataListName: string, parentKey?: string, masterKey?: string, reset?: boolean, needParentKey: boolean = true) {
    return this.getListWithMasterKey(stepId, fieldName, dataListName, parentKey, masterKey, reset, needParentKey).then((options) => {
      const control = this.steps[stepId].form.group.get(fieldName);
      if (options?.length > 0) {
        if(this.data.recordActionType !== RecordActionTypes.EditMassiveRecord) {
          control.addValidators(Validators.required);
        }
      } else {
        control.removeValidators(Validators.required);
      }
      control.updateValueAndValidity();
    })
  }

  closeDialog() {
    if(this.data.recordActionType === RecordActionTypes.ViewRecord) {
      this.dialogRef.close();
      return;
    }

    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: {
        title: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.CLOSE.DIALOG.TITLE',
        message: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.CLOSE.DIALOG.MESSAGE',
        noLabel: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.CLOSE.DIALOG.NO_LABEL',
        yesLabel: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.CLOSE.DIALOG.YES_LABEL'
      },
      minWidth: '250px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {       
        this.dialogRef.close();
      }
    });
  }

  editMassive() {
    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: { 
        title: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_MASSIVE_RECORD.DIALOG.TITLE',
        message: this.translationService.instant('DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_MASSIVE_RECORD.DIALOG.MESSAGE', { elements: this.data.UUIDs.length }),
        noLabel: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_MASSIVE_RECORD.DIALOG.NO_LABEL',
        yesLabel: 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_MASSIVE_RECORD.DIALOG.YES_LABEL',
      },
      minWidth: '250px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {      
        const loadingRef = this.dialog.open(SMTLoadingDialogComponent, {
          data: {
            title: 'Cargando...',
          },
          minWidth: '250px'
        });

        const udeuEditMassiveRecord = new UdeuEditMassiveRecord(this.data.UUIDs);
        const udeuRecord = new UdeuRecord();
    
        udeuRecord.classification = this.createClassification();
        udeuRecord.data = this.createData();
        udeuRecord.authors = this.createAuthors();
        udeuRecord.info = this.createInfo();
        udeuEditMassiveRecord.data = udeuRecord;
        
        const addFields: string[] = [];
        udeuEditMassiveRecord.deleteFields = [];
        Object.values(this.steps).forEach((step) => {
          const fields = step.form.fields;
          if(!step.disabled &&  fields) {
            const entries = Object.entries(fields);
            entries.forEach(([key, field]) => {
              if((!field.type || field.type === MatFormFieldType.SELECT_MULTIPLE || field.type === MatFormFieldType.INPUT)){
                  if((!field.selectedMenuOption || field.selectedMenuOption.id === 'add')) 
                    addFields.push(key);
                  else if((!field.selectedMenuOption || field.selectedMenuOption.id === 'delete')){
                    udeuEditMassiveRecord.deleteFields.push(key);
                  }
              }else if(field.delete)
                  udeuEditMassiveRecord.deleteFields.push(key);
            })
          }
        });
        udeuEditMassiveRecord.addFields = addFields;

        this.recordService.editMassiveRecords(udeuEditMassiveRecord).then(() => {
          this.dialogRef.close();
          const route = '/viewer/records';
          this.router.url === route ? this.store.dispatch(new ReloadCustomListTableAction(false)) : this.router.navigate([route]);
        }).catch((err) => {
          console.error("ERROR", err);
          this.store.dispatch(new SnackbarErrorAction('Hubo un error inesperado. Contacte con el administrador.'));
        }).finally(() => {
          loadingRef.close();
        });
      }
    });
  }

  createRecord(draft = false, edit: boolean = false) {
    if(this.filesFormGroup.invalid && this.filesFormGroup.controls[FILES_FIELD].hasError('maxSize')) {
      const fileSizeLimit = this.aldenService.getAppConfigProp(APP_CONFIG_FILE_SIZE_LIMIT);
      this.store.dispatch(new SnackbarWarningAction('ALDEN.MESSAGES.ERRORS.FILE_SIZE_LIMIT', { fileSizeLimit }));
      return;
    }

    // Crear nuevo borrador o Crear nuevo registro
    let title = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.CREATE_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.TITLE`;
    let message = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.CREATE_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.MESSAGE`;
    let noLabel = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.CREATE_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.NO_LABEL`;
    let yesLabel = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.CREATE_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.YES_LABEL`;

    if(this.data?.recordActionType === RecordActionTypes.EditRecord) {
      if(edit) { 
        // Editar borrador o Editar registro
        title = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.TITLE`;
        message = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.MESSAGE`;
        noLabel = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.NO_LABEL`;
        yesLabel = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.YES_LABEL`;
      } else {  
        // Eliminar borrador y crear registro
        title = 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_RECORD.DIALOG.CREATE_RECORD.TITLE';
        message = 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_RECORD.DIALOG.CREATE_RECORD.MESSAGE';
        noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_RECORD.DIALOG.CREATE_RECORD.NO_LABEL';
        yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.EDIT_RECORD.DIALOG.CREATE_RECORD.YES_LABEL';
      }
    } else if(this.data?.recordActionType === RecordActionTypes.DuplicateRecord) {
      // Duplicar como un nuevo borrador o Duplicar como un nuevo registro
      title = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.DUPLICATE_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.TITLE`;
      message = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.DUPLICATE_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.MESSAGE`;
      noLabel = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.DUPLICATE_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.NO_LABEL`;
      yesLabel = `DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.DUPLICATE_RECORD.DIALOG.${draft ? 'DRAFT' : 'RECORD'}.YES_LABEL`;
    }

    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: { title, message, noLabel, yesLabel },
      minWidth: '250px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {      
        const loadingRef = this.dialog.open(SMTLoadingDialogComponent, {
          data: {
            title: 'Cargando...',
          },
          minWidth: '250px'
        });

        const udeuCreateRecord = new UdeuCreateRecord();
        const udeuRecord = new UdeuRecord();

        udeuRecord.classification = this.createClassification();
        udeuRecord.data = this.createData();
        udeuRecord.authors = this.createAuthors();
        udeuRecord.info = this.createInfo();
        udeuRecord.context = this.createContext();
        udeuRecord.files = this.createFiles(udeuCreateRecord);
        udeuRecord.locations = this.createLocations();
        
        udeuCreateRecord.data = udeuRecord;

        const UUIDs = this.data.UUIDs;
        const uuid = UUIDs?.length === 1 ? UUIDs[0] : null;
        const promise = edit 
        ? this.recordService.updateRecord(uuid, udeuCreateRecord) 
        : uuid 
        ? this.recordService.createUpdateRecord(uuid, udeuCreateRecord, draft, this.data.recordActionType === RecordActionTypes.DuplicateRecord) 
        : this.recordService.createRecord(udeuCreateRecord, draft);
        promise.then(() => {
          this.dialogRef.close();
          const route = '/viewer/records';
          this.router.url === route ? this.store.dispatch(new ReloadCustomListTableAction(false)) : this.router.navigate([route]);
        }).catch(async (err) => {
          console.error("ERROR", err);
          if(err?.status === 409)
            this.store.dispatch(new SnackbarErrorAction(this.translationService.instant('DEUSTO.MESSAGES.ERRORS.DUPLICATE')));
          else
            this.store.dispatch(new SnackbarErrorAction('Hubo un error inesperado. Contacte con el administrador.'));
        }).finally(() => {
          loadingRef.close();
        });
      }
    });
  }

  createClassification(): UdeuClassification {
    const classification = new UdeuClassification();
    classification.fund = (this.clasificationFormGroup.get(FONDO_FIELD).value as KeyValue<string,string>)?.key;
    classification.classificationGroup = (this.clasificationFormGroup.get(GRUPO_CLASIFICACION_FIELD).value as KeyValue<string,string>)?.key;
    classification.classification = (this.clasificationFormGroup.get(CLASIFICACION_FIELD).value as KeyValue<string,string>)?.key;
    classification.division = (this.clasificationFormGroup.get(DIVISION_FIELD).value as KeyValue<string,string>)?.key;
    classification.subdivision = (this.clasificationFormGroup.get(SUBDIVISION_FIELD).value as KeyValue<string,string>)?.key;
    classification.specificSubdivision = (this.clasificationFormGroup.get(SUBDIVISION_ESP_FIELD).value as KeyValue<string,string>)?.key;
    const nominalSubdivision = (this.clasificationFormGroup.get(SUBDIVISION_NOM_FIELD).value as KeyValue<string,string>[]);
    classification.nominalSubdivision = nominalSubdivision?.length > 0 ? nominalSubdivision.map((opt) => opt.key) : [];
    return classification;
  }

  createData(): UdeuData {
    const data = new UdeuData();
    data.category = (this.dataFormGroup.get(CATEGORIA_FIELD).value as KeyValue<string,string>)?.key;
    data.typology = (this.dataFormGroup.get(TIPOLOGIA_FIELD).value as KeyValue<string,string>)?.key;
    data.title = (this.dataFormGroup.get(TITULO_FIELD).value as KeyValue<string,string>)?.key;
    data.depositProv = (this.dataFormGroup.get(DEPOSITO_PROVISIONAL_FIELD).value as KeyValue<string,string>)?.key;
    data.descLevel = (this.dataFormGroup.get(NIVEL_DESC_FIELD).value as KeyValue<string,string>)?.key;
    data.startDate = this.dataFormGroup.get(FECHA_INICIO_FIELD).value;
    data.endDate = this.dataFormGroup.get(FECHA_FIN_FIELD).value;
    data.supportVolume = this.dataFormGroup.get(VOLUMEN_SOP_FIELD).value;
    return data;
  }
  
  createAuthors(): UdeuAuthor[] {
    const value = (this.authorsFormGroup.get(AUTHORS_FIELD).getRawValue() as UdeuAuthor[]);
    return value?.length > 0 ? value : [];
  }

  createInfo(): UdeuInfo {
    const info = new UdeuInfo();
    info.scopeContent = this.infoFormGroup.get(ALCANCE_CONTENIDO_FIELD).value;
    const descriptors = (this.infoFormGroup.get(DESCRIPTORES_FIELD).value as KeyValue<string,string>[]);
    info.descriptors = descriptors?.length > 0 ? descriptors.map((opt) => opt.key) : [];
    const thesaurus = (this.infoFormGroup.get(TESAURO_FIELD).value as KeyValue<string,string>[]);
    info.thesaurus = thesaurus?.length > 0 ? thesaurus.map((opt) => opt.key) : [];
    return info;
  }

  createContext(): UdeuContext {
    const context = new UdeuContext();
    context.valuation = (this.contextFormGroup.get(VALORACION_FIELD).value as KeyValue<string,string>)?.key;
    context.access = (this.contextFormGroup.get(ACCESO_FIELD).value as KeyValue<string,string>)?.key;
    context.location = this.contextFormGroup.get(LOCALIZACION_FIELD).value;
    context.reproduction = this.contextFormGroup.get(REPRODUCCION_FIELD).value;
    context.language = this.contextFormGroup.get(LENGUA_FIELD).value;
    context.associatedDocuments = this.contextFormGroup.get(DOCUMENTOS_ASOCIADOS_FIELD).value;
    context.conservation = (this.contextFormGroup.get(CONSERVACION_FIELD).value as KeyValue<string,string>)?.key;
    context.notes = this.contextFormGroup.get(NOTAS_FIELD).value;
    return context;
  }

  createFiles(udeuCreateRecord: UdeuCreateRecord): UdeuFile[] {
    const value = (this.filesFormGroup.get(FILES_FIELD).value as AttachedFile[]);
    if(value?.length > 0) {
      udeuCreateRecord.files = [];
      return value.map((file) => {
        if(!file.uuid) {
          const udeuCreateFile: UdeuCreateFile = { id: file.fileId, file: file.file };
          udeuCreateRecord.files.push(udeuCreateFile);
        }

        const udeuFile = new UdeuFile(file.uuid, file.fileId, file.name, '', file.description);
        return udeuFile;
      });
    }
    return [];
  }

  createLocations(): UdeuLocation[] {
    const value = (this.locationsFormGroup.get(LOCATIONS_FIELD).getRawValue() as UdeuLocation[]);
    return value?.length > 0 ? value?.map((location) => {
        return { ...location, deposit: (location.deposit as KeyValue<string, string>).key };
    }) : [];
  }

  stepSelectionChange(event: StepperSelectionEvent) {
    // Necesario para marcar los selectores multiple
    event.previouslySelectedStep.stepControl.markAllAsTouched();
  }

  isCompleted(matStep: MatStep) {
    const recordActionType = this.data?.recordActionType ?? RecordActionTypes.CreateRecord;
    switch (recordActionType) {
      case RecordActionTypes.CreateRecord:
        return !matStep.stepControl.invalid && matStep.interacted;

      case RecordActionTypes.EditRecord:
      case RecordActionTypes.DuplicateRecord:
        return !matStep.stepControl.invalid;
    
      default:
        return false;
    }
  }

  formatDate(date: string): Moment {
    if(date) {
       const [day, month, year] = date.split('/').map(Number);
       const dateDate = new Date(year, month - 1, day);
       const formatedDate = dateDate.toISOString();
      return this.momentDate(formatedDate);
    }
    return null;
  }

  momentDate(date: string): Moment {
    if(date) {
      const dateMoment: Moment = moment(date, 'YYYY-MM-DD');
      return dateMoment;
    }
    return null;
  }

  selectMenuOption(selectedMenuOption: FormFieldMenuOption, formfield: UDeuStepFormField) {
    let i = this.editMassiveOptions.indexOf(selectedMenuOption) + 1;
    if(i == this.editMassiveOptions.length) i = 0;
    formfield.selectedMenuOption =  this.editMassiveOptions[i];
    if(formfield.selectedMenuOption.id === 'delete' && !formfield.optional && !this.record.draft){
      formfield.selectedMenuOption =  this.editMassiveOptions[0];
    }
    //formfield.selectedMenuOption = this.editMassiveOptions.find((opt) => opt.id !== selectedMenuOption.id);
  }
}
